import {useState, useEffect} from "react";
import {useNavigate} from 'react-router-dom';
import {onlineProcessesService} from "../../services";
import {useLoader} from "@quadral/quadral-component-common/dist/components/loader/LoaderContext";
import QuadralList from "@quadral/quadral-component-common/dist/components/list";
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import QuadralBadge from "@quadral/quadral-component-common/dist/components/badge";
import QuadralTypography from '@quadral/quadral-component-common/dist/components/typography';

const STATUS_LABEL_MAP = {
    'brouillon': 'Brouillon',
    'a_planifier': 'À planifier',
    'planifiee': 'Planifiée',
    'en_cours': 'En cours',
    'suspendue': 'Suspendue',
    'terminee': 'Terminée',
    'annulee': 'Annulée'
};

const STATUS_COLOR_MAP = {
    'brouillon': 'secondary',
    'a_planifier': 'warning',
    'planifiee': 'warning',
    'en_cours': 'success',
    'suspendue': 'info',
    'terminee': 'secondary',
    'annulee': 'secondary'
};

const buildColumns = (navigate) => [
    {id: 'name', label: 'Libellé', sortable: true},
    {
        id: 'startDate',
        label: 'Date de début',
        sortable: true,
        render: (row) => row.startDate ? new Date(row.startDate).toLocaleDateString('fr-FR') : '-'
    },
    {
        id: 'endDate',
        label: 'Date de fin',
        sortable: true,
        render: (row) => row.endDate ? new Date(row.endDate).toLocaleDateString('fr-FR') : '-'
    },
    {id: 'ownerCompanyName', label: 'Référence client', sortable: true},
    {
        id: 'status',
        label: 'Statut',
        sortable: true,
        render: (row) => (
            <QuadralBadge
                label={STATUS_LABEL_MAP[row.status] || row.status}
                color={STATUS_COLOR_MAP[row.status] || 'info'}
            />
        )
    },
    {
        id: 'actions',
        label: '',
        render: (row) => (
            <QuadralButton onClick={() => navigate(`/enquetes/${row.id}/participations`)}>
                Ouvrir
            </QuadralButton>
        )
    }
];

const Surveys = () => {
    const navigate = useNavigate();
    const [surveys, setSurveys] = useState([]);
    const {showLoader, hideLoader} = useLoader();

    useEffect(() => {
        showLoader();
        onlineProcessesService.getSurveys()
            .then((response) => {
                setSurveys(response || []);
                hideLoader();
            })
            .catch(err => {
                console.error(err);
                hideLoader();
            });
    }, [showLoader, hideLoader]);

    return (
        <div className="page-content">
            <QuadralTypography variant="modalTitle" gutterBottom> Enquêtes</QuadralTypography>
            <QuadralList
                columns={buildColumns(navigate)}
                rows={surveys}
                sortable={true}
            />
        </div>
    );
};

export default Surveys;